
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import PropertyValue from '@/components/main/PropertyValue.vue'
    import { convertMdiBracketToIcon } from '@/mdi';
    import { Mutation, Getter } from 'vuex-class';
    import IconMenu from '@/components/main/IconsMenu/IconMenu.vue';
    import IconItem from '@/components/main/IconsMenu/IconItem';

    const namespace = 'main';

    @Component({
        components: {
            PropertyValue,
            IconMenu,
        },
    })
    export default class Properties extends Vue {

        @Prop({ default: null }) public locationProperties: any;
        @Prop({ default: null }) public location: any;
        @Prop({ default: null }) public subModel: any;
        @Prop({ default: null }) public model: any;
        @Prop({ default: (() => []) }) private propertyIcons: IconItem[];
        @Prop({ default: (() => [IconItem.GetDissabled()]) }) private poiIcons: IconItem[];
        @Prop({ default: false }) public showIconMenu: boolean;
        @Mutation('SET_POISINRANGEFIELDSTATETOGGLE', { namespace }) setPoisInRangeFieldStateToggle: any;
        @Getter('getPoisInRangeFieldState', { namespace }) getPoisInRangeFieldState: any;

        private convertMdiBracketToIcon = convertMdiBracketToIcon;
        
        private toggleField(fieldName: string) {
            this.setPoisInRangeFieldStateToggle(fieldName)
        }

        private isDisabled(fieldName: string): boolean {
            return this.getPoisInRangeFieldState[fieldName];
        }

        private propertySelect(property) {
            property.dependencyProperties.forEach(dependencyProperty => {
                document.querySelectorAll(".tbdc-property-" + dependencyProperty.propertyName).forEach(element => {
                    element.classList.add("tbdc-active-dependency");
                    element.classList.add(dependencyProperty.isDependency ? "tbdc-dependency" : "tbdc-influence");
                });
            });
        }

        private propertyDeselect() {
            document.querySelectorAll(".tbdc-active-dependency").forEach(element => {
                element.classList.remove("tbdc-active-dependency");
                element.classList.remove("tbdc-dependency");
                element.classList.remove("tbdc-influence");
            });
        }

        private propertyToIconItem(property) {
            const knownIconItemIndex = this.propertyIcons.map(icon => icon.name).indexOf(property.name);
            if (knownIconItemIndex >= 0) {
                return this.propertyIcons[knownIconItemIndex];
            }
            var enabled = property.dependencyProperties as boolean;
            if (enabled) {
                enabled = property.dependencyProperties.length > 0
            }

            const iconItem = new IconItem(property.name, "mdi-link", "dependencies", () => this.propertySelect(property), () => this.propertyDeselect(), this.propertyIcons, true, enabled);
            this.propertyIcons.push(iconItem);
            return iconItem;
        }

        private poiToIconItem(property) {
            if (property.autoCalculateType !== 6) {
                return this.poiIcons[0]; 
            }
            const enabled = property.numberValue > 0;
            const selected = !this.isDisabled(property.poiSetName) && enabled

            const knownPoiIconItemIndex = this.poiIcons.map(icon => icon.name).indexOf(property.name + "-poi");
            if (knownPoiIconItemIndex >= 0) {
                const knownPoiIcon = this.poiIcons[knownPoiIconItemIndex];
                knownPoiIcon.enabled = enabled;
                knownPoiIcon.selected = selected

                return knownPoiIcon;
            }

            const iconItem = new IconItem(property.name + "-poi", "mdi-map-marker-circle", "poi", () => this.toggleField(property.poiSetName), () => this.toggleField(property.poiSetName), [], false, selected, enabled);
            this.poiIcons.push(iconItem);
            return iconItem;
        }

        get groupedBySectionViewOrder() {
            return this.filteredLocationProperties?.reduce((acc: any, property: any) => {
                const key = property.sectionViewOrder;
                if (!acc[key]) {
                    acc[key] = [];
                }
                acc[key].push(property);
                return acc;
            }, {} as Record<number, []>);
        }
        
        get filteredLocationProperties() {
            const _self = this;
            return this.locationProperties.filter(function (locationProperty: any) {
                
                if ((locationProperty.subModelId == null || locationProperty.subModelId == _self.subModel.id) && locationProperty.visible) return (locationProperty.title != null)
                    //&& (locationProperty.propertyType != 5 || _self.location.changeType == 1 || _self.location.changeType == 0)  
                    //&& (locationProperty.propertyType != 6 || _self.location.changeType == 0 || _self.location.changeType == 2)

                    ;
            });
        }

        getChoice(choices: any, value: any) {
            let choice = null;
            choices.forEach(function (item: any) {
                if (item.key == value) choice = item.value;
            });
            if (choice == null) choice = value;
            return choice;
        }

    }
